'use strict';

$(document).ready(function () {
    var rowId=1;
    $('.b2b_add_product').on('click', function (e) {
        var rowCount = $(".sku-qtt-row").length;
        if (rowCount == 1) {
            $(".sku-qtt-row .b2b_delete_row").toggle();
        }
        if (rowCount < 10) {
            $('.sku-qtt-container').append(
                `<div class="sku-qtt-row">
                    <div class="sku-qtt-item input-sku">
                        <label for="b2b_product_${++rowId}">`+Resources.B2B_PRODUCT_SKU+`</label>
                        <input class="input-text valid" type="text"  id="b2b_product_${rowId}" name="b2b_product_sku" value="" maxlength="20" placeholder="`+Resources.B2B_PRODUCT_SKU_PH+`" aria-invalid="false"/>
                    </div>
                    <div class="sku-qtt-item input-qtt">
                        <label for="prod_quantity_${rowId}">`+Resources.B2B_QUANTITY+`</label>
                        <input class="input-text valid" type="number" id="prod_quantity_${rowId}" name="b2b_quantity" placeholder="0" maxlength="100" aria-invalid="false"/>
                    </div>
                    <div class="btn-col">
                        <button type="button" class="sku-qtt-item b2b_delete_row">
                            <span class="icon--remove"></span>
                            <span class="display--small-up text">`+Resources.REMOVE+`</span>
                        </button>
                    </div>
                </div>`
            );
        }
        if (rowCount + 1 == 10) {
            $('.b2b_add_product').attr('disabled', true);
        }
    });

    $('.sku-qtt-container').on('click','.b2b_delete_row', function () {
        $(this).closest('.sku-qtt-row').remove();
        $('.b2b_add_product').attr('disabled', false);
        var rowCount = $('.sku-qtt-row').length;
        if (rowCount == 1) {
            $(".sku-qtt-row .b2b_delete_row").toggle();
        }
    });
});



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/b2borders.js